var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaIcSearchBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.07105 5.37016C9.07105 7.41519 7.41323 9.07301 5.36821 9.07301C3.32318 9.07301 1.66536 7.41519 1.66536 5.37016C1.66536 3.32514 3.32318 1.66732 5.36821 1.66732C7.41323 1.66732 9.07105 3.32514 9.07105 5.37016ZM10.4044 5.37016C10.4044 8.15157 8.14961 10.4063 5.36821 10.4063C2.5868 10.4063 0.332031 8.15157 0.332031 5.37016C0.332031 2.58876 2.5868 0.333984 5.36821 0.333984C8.14961 0.333984 10.4044 2.58876 10.4044 5.37016ZM10.3776 8.9511L9.0614 10.2673L13.1201 14.3261C13.8471 13.5991 13.8471 12.4205 13.1201 11.6936L10.3776 8.9511Z",
    fill: "black",
    fillOpacity: 0.7
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaIcSearchBlack);
export default __webpack_public_path__ + "static/media/pa_ic_searchBlack.572abbeb180df6b25782d30b18fe67e4.svg";
export { ForwardRef as ReactComponent };